<h2>นโยบายคุ้มครองข้อมูลส่วนบุคคล</h2>
<p style="text-indent: 2.5em;">
    ข้อความแสดงนโยบายคุ้มครองข้อมูลส่วนบุคคลออนไลน์ของบริษัท โรช ไดแอกโนสติกส์ เอเชีย แปซิฟิก จำกัด ขอขอบพระคุณ ที่ท่านได้เข้าชมเว็บไซต์ของโรช
    หรือติดต่อบริษัทฯ ผ่านทางอีเมล
</p>
<p style="text-indent: 2.5em;">
    โรชตระหนักถึงความสำคัญยิ่งของการคุ้มครองสิทธิความเป็นส่วนตัวของผู้เข้าชมเว็บไซต์ของบริษัทฯ โดยเฉพาะอย่างยิ่งข้อมูลทางด้านสุขภาพของท่าน
    นั่นจึงเป็นเหตุผลที่ทางบริษัทฯ มีมาตรการรับรองที่จำเป็นตามมาตรฐานการคุ้มครองสิทธิ์ส่วนบุคคลในระดับสากล บริษัทฯ ดูแล “ข้อมูลส่วนบุคคล”
    ตามนโยบาย “Roche Directive on the Protection of Personal Data“ และตามกฎหมายแห่งสหภาพยุโรป สวิตเซอร์แลนด์ และกฏหมายอื่นๆ
    ในแต่ละประเทศที่เกี่ยวข้องกับการจัดเก็บ ประมวลผล เข้าถึง และโอนถ่ายข้อมูลส่วนบุคคล เว็บไซต์ของโรชที่แสดงนโยบายคุ้มครองข้อมูลส่วนบุคคล
    (ซึ่งต่อไปนี้จะเรียกว่า “นโยบาย”) และที่สอบถามข้อมูลใดๆ ของท่านจะถูกกำหนดให้อยู่ภายใต้กรอบแห่งนโยบายนี้ ในเรื่องการรวบรวม
    เก็บรักษา และคุ้มครองข้อมูลส่วนบุคคลของท่าน และให้สอดคล้องกับระเบียบ ข้อบังคับ และกฎหมายที่บังคับใช้ นโยบายนี้ครอบคลุมถึงข้อมูลส่วนบุคคล
    (ดังคำจำกัดความด้านล่าง) ที่รวบรวมผ่านระบบการสื่อสารออนไลน์ของโรช (อาทิ เว็บไซต์ อีเมล และเครื่องมือออนไลน์อื่นๆ) ที่แสดงลิงก์มายังนโยบายนี้
    นโยบายนี้ไม่ครอบคลุมถึงข้อมูลส่วนบุคคลที่รวบรวมผ่านทางการสื่อสารแบบออฟไลน์ เว้นแต่ในกรณีที่ข้อมูลส่วนบุคคลนั้นถูกนำมาประกอบเข้ากับข้อมูลส่วนบุคคลที่รวบรวมผ่านทางการสื่อสารออนไลน์ของโรช
    นโยบายนี้ไม่ครอบคลุมถึงทรัพยากรออนไลน์ของบุคคลที่สามที่อาจมีลิงก์เข้ากับเว็บไซต์ของโรช โดยที่โรชไม่สามารถควบคุมเนื้อหาหรือรูปแบบการใช้งานข้อมูลส่วนบุคคลของทรัพยากรดังกล่าวได้
</p>
<p style="text-indent: 2.5em;">
    บริษัทฯ จะรวบรวมข้อมูลที่ระบุตัวตนของท่านได้เฉพาะเมื่อท่านให้ข้อมูลเหล่านั้นกับทางบริษัทฯ บริษัทฯ จะไม่แบ่งปันข้อมูลที่ใช้ระบุตัวตนของท่านได้กับบุคคลที่สามเพื่อให้นำไปใช้ในทางการตลาด
    เว้นแต่เมื่อท่านได้ให้อนุญาตแล้วอย่างชัดเจน กรุณาศึกษาทบทวนนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้เพื่อให้ทราบถึงวิธีการที่บริษัทฯ
    รวบรวม ใช้ แบ่งปัน และให้การคุ้มครองกับข้อมูลออนไลน์
</p>
<ul style="margin-left: 3em;">
    <li>
        <a href="/policy#bullet1">ข้อมูลที่รวบรวมได้</a>
    </li>
    <li>
        <a href="/policy#bullet2">ทางเลือกของท่าน</a>
    </li>
    <li>
        <a href="/policy#bullet3">ความคุ้มครอง</a>
    </li>
    <li>
        <a href="/policy#bullet4">การใช้ข้อมูล</a>
    </li>
    <li>
        <a href="/policy#bullet5">การแบ่งปันและโอนถ่ายข้อมูล</a>
    </li>
    <li>
        <a href="/policy#bullet6">ลิงก์ไปยังเว็บไซต์อื่น</a>
    </li>
    <li>
        <a href="/policy#bullet7">นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับเยาวชน</a>
    </li>
    <li>
        <a href="/policy#bullet8">ข้อมูลเพิ่มเติมบนเว็บไซต์</a>
    </li>
    <li>
        <a href="/policy#bullet9">ข้อความสำหรับผู้ใช้งานเว็บไซต์ในเชิงธุรกิจหรือวิชาชีพ</a>
    </li>
    <li>
        <a href="/policy#bullet10">การปรับนโยบายคุ้มครองข้อมูลส่วนบุคคลให้เป็นปัจจุบัน</a>
    </li>
    <li>
        <a href="/policy#bullet11">วิธีติดต่อโรช</a>
    </li>
</ul>

<h3 id="bullet1">ข้อมูลที่รวบรวมได้</h3>
<p style="text-indent: 2.5em;">วิธีทั่วไปที่โรชใช้เพื่อรวบรวมข้อมูลของท่านผ่านทางออนไลน์มีสองวิธี</p>

<h4>ข้อมูลที่บริษัทฯ ได้มา</h4>
<p style="text-indent: 2.5em;">
    <font style="font-weight: bold">ข้อมูลที่ใช้ระบุตัวตนได้:</font> ท่านสามารถเข้าชมเว็บไซต์ของบริษัทฯ ได้โดยไม่ต้องให้ข้อมูลส่วนตัวใดๆ บริษัทฯ อาจจัดเก็บข้อมูลที่ใช้ระบุตัวตนของท่านได้
    (เช่น ชื่อ ที่อยู่ หมายเลขโทรศัพท์ อีเมลแอดเดรส หรือข้อมูลระบุตัวตนอื่นๆ) เฉพาะเมื่อท่านให้ข้อมูลเหล่านั้นกับทางบริษัทฯ
    บริษัทฯ อาจเก็บข้อมูลด้านสุขภาพของท่านที่ท่านได้ให้ไว้ผ่านทางการทำแบบสอบถามหรือการตอบคำถามของบริษัทฯ
</p>
<p style="text-indent: 2.5em;">
    <font style="font-weight: bold">ข้อมูลรวม:</font> ในบางกรณี บริษัทฯ จะลบข้อมูลส่วนที่ใช้ระบุตัวตนได้ออกจากข้อมูลที่ท่านให้ แล้วเก็บข้อมูลที่เหลือไว้ในรูปของชุดข้อมูลหรือข้อมูลรวมที่บริษัทฯ
    จะนำไปรวมกับข้อมูลอื่นๆ เพื่อผลทางการทำสถิติในภาพรวมและไม่มีการระบุตัวบุคคล (อาทิ จำนวนผู้เข้าชม ชื่อโดเมนต้นทางของผู้ให้บริการอินเตอร์เน็ต)
    เพื่อใช้ในการพัฒนาปรับปรุงสินค้าและบริการของบริษัทฯ
</p>

<h4>ข้อมูลที่รวบรวมได้โดยอัตโนมัติ</h4>
<p style="text-indent: 2.5em;">บริษัทฯ และผู้ให้บริการบุคคลที่สามบางรายที่ทางบริษัทฯ ร่วมงานด้วยจะได้รับข้อมูลบางอย่างโดยอัตโนมัติเมื่อท่านสื่อสารกับบริษัทฯ
    ผ่านทางหน้าเว็บไซต์และทางอีเมล บริการและเทคโนโลยีอัตโนมัติที่บริษัทฯ ใช้อาจรวมถึง การเก็บบันทึกรายการของเซิร์ฟเวอร์เว็บไซต์หรือไอพีแอดเดรส
    (web server logs/IP address), คุกกี้ (cookies), เว็บบีคอน (web beacons) ตลอดจนเครื่องมือจัดทำคอนเทนต์ และแอปพลิเคชั่นต่างๆ
    จากบุคคลที่สาม
</p>

<p style="text-indent: 2.5em;">
    <font style="font-weight: bold">บันทึกรายการของเซิร์ฟเวอร์เว็บไซต์หรือไอพีแอดเดรส:</font> ไอพีแอดเดรสเป็นตัวเลขที่ใช้ระบุคอมพิวเตอร์ของท่านทุกครั้งที่ท่านเชื่อมต่ออินเตอร์เน็ต
    ไอพีแอดเดรสถูกใช้เพื่อระบุตัวตนของคอมพิวเตอร์ทุกเครื่องบนอินเตอร์เน็ต ช่วยให้คอมพิวเตอร์และเซิร์ฟเวอร์สามารถรู้จำและสื่อสารกันได้
    โรชรวบรวมข้อมูลไอพีแอดเดรสไว้เพื่อการจัดการระบบ และส่งรายงานข้อมูลรวมไปยังบริษัทในเครือ พันธมิตรทางธุรกิจ และ/หรือผู้ค้าบางรายเพื่อให้สามารถทำการวิเคราะห์เว็บไซต์
    และตรวจทวนประสิทธิภาพของเว็บไซต์
</p>
<p style="text-indent: 2.5em;">
    <font style="font-weight: bold">คุกกี้:</font> คุกกี้เป็นชิ้นส่วนข้อมูลที่ถูกนำไปวางไว้บนฮาร์ดไดร์ฟของคอมพิวเตอร์ของท่านโดยอัตโนมัติเมื่อท่านเข้าสู่เว็บไซต์บางแห่ง
    คุกกี้สามารถระบุเบราเซอร์ของท่านเพื่อจำแนกให้เซิร์ฟเวอร์เห็นความแตกต่างได้ คุกกี้ช่วยให้บริษัทฯ สามารถจัดเก็บข้อมูลบนเซิร์ฟเวอร์เพื่อมอบประสบการณ์การใช้เว็บที่ดีขึ้นแก่ท่าน
    รวมถึงเพื่อการวิเคราะห์เว็บไซต์ และตรวจทวนประสิทธิภาพของเว็บไซต์ เว็บเบราเซอร์ส่วนใหญ่ถูกกำหนดให้ยอมรับคุกกี้ แม้ในกรณีที่ท่านตั้งเบราเซอร์ใหม่ไม่ให้รับคุกกี้
    หรือให้แจ้งเตือนเมื่อมีการส่งคุกกี้มาที่เครื่องของท่านก็ตาม อย่างไรก็ดี บางส่วนบนเว็บไซต์ของบริษัทฯ อาจไม่สามารถทำงานได้ตามปกติหากท่านไม่ยอมรับคุกกี้
</p>
<p style="text-indent: 2.5em;">
    <font style="font-weight: bold">เว็บบีคอน:</font> โรชอาจใช้เทคโนโลยีอินเตอร์เน็ตที่มีผู้ใช้งานร่วมกันอย่างแพร่หลายในอีเมลหรือบนหน้าเว็บไซต์บางแห่งของบริษัทฯ
    เทคโนโลยีดังกล่าวนี้เรียกว่า “เว็บบีคอน” (web beacon หรืออาจเป็นที่รู้จักในชื่อ “action tag” หรือ “clear GIF technology”
    เว็บบีคอนช่วยวิเคราะห์ประสิทธิผลของเว็บไซต์โดยการใช้มาตรวัดปัจจัยต่างๆ เช่น จำนวนผู้เข้าชมเว็บไซต์ หรือมีผู้คลิ้กจุดสำคัญต่างๆ
    บนเว็บไซต์มากน้อยเพียงใด
</p>
<p style="text-indent: 2.5em;">
    เว็บบีคอน คุกกี้ และเทคโนโลยีติดตามอื่นๆ จะไม่เก็บข้อมูลที่ใช้ระบุตัวตนของท่านโดยอัตโนมัติ นอกจากกรณีที่ท่านยินยอมให้ข้อมูลส่วนบุคคลเหล่านั้นโดยสมัครใจ
    เช่น โดยการลงทะเบียน หรือส่งอีเมล เทคโนโลยีติดตามอัตโนมัติเหล่านี้ถึงถูกนำมาใช้เพื่อมอบข้อมูลเพิ่มเติมที่เกี่ยวข้องกับการใช้งานเว็บไซต์
    และ/หรือการโต้ตอบผ่านอีเมลของท่าน ทั้งนี้ก็เพื่อยกระดับประโยชน์ที่ท่านจะได้รับ
</p>
<p style="text-indent: 2.5em;">
    <font style="font-weight: bold">บริการต่างๆ:</font> บริษัทฯ อาจมอบบริการต่างๆ โดยอิงจากแอปพลิเคชั่น และเครื่องมือด้านคอนเทนต์ของบุคคลที่สามผ่านบางหน้าเว็บไซต์ของโรช
    อาทิ Google Maps หรือ QUARTAL FLIFE บุคคลที่สามเหล่านี้อาจได้รับข้อมูลบางประการโดยอัตโนมัติเมื่อท่านติดต่อสื่อสารกับทางบริษัทฯ
    ผ่านหน้าเว็บไซต์ของบริษัทฯ โดยใช้แอปพลิเคชั่นและเครื่องมือของบุคคลที่สามเหล่านี้
</p>
<h3 id="bullet2">ทางเลือกของท่าน</h3>
<p style="text-indent: 2.5em;">
ท่านมีทางเลือกมากมายในการใช้เว็บไซต์ของบริษัทฯ ท่านสามารถเลือกที่จะไม่ให้ข้อมูลส่วนตัวใดๆ ทั้งสิ้นที่จะสามารถใช้ระบุตัวตนท่านได้
โดยปฏิเสธการกรอกแบบฟอร์มหรือช่องใส่ข้อมูลบนเว็บไซต์ของบริษัทฯ และปฏิเสธการใช้บริการพิเศษเฉพาะบุคคลใดๆ ในกรณีที่ท่านเลือกให้ข้อมูลส่วนตัว
ท่านมีสิทธิในการตรวจดู และแก้ไขข้อมูลได้ตลอดเวลาโดยผ่านทางการใช้แอปพลิเคชั่น เว็บไซต์บางหน้าอาจขออนุญาตท่านเพื่อขอใช้ข้อมูลของท่าน
ท่านมีสิทธิที่จะยินยอมหรือปฏิเสธคำขอนั้นได้ หากท่านได้เลือกสมัครใช้บริการ หรือรูปแบบการสื่อสารบางประเภท เช่น ข่าวสารทางอีเมล
ท่านสามารถที่จะยกเลิกการสมัครได้ตลอดเวลาโดยปฏิบัติตามขั้นตอนที่ได้ระบุไว้สำหรับบริการนั้นๆ หากท่านเลือกที่จะยกเลิกบริการหรือการสื่อสารใดๆ
บริษัทฯ จะทำการลบข้อมูลของท่านออกจากบริการหรือการสื่อสารนั้นโดยทันที ทั้งนี้ บริษัทฯ อาจต้องมีการขอข้อมูลเพิ่มเติมบางอย่างเพื่อให้สามารถประมวลตามคำขอของท่านได้
</p>
<p style="text-indent: 2.5em;">
ดังที่ได้กล่าวมาแล้วข้างต้น หากท่านต้องการป้องกันไม่ให้คุกกี้ติดตามความเคลื่อนไหวของท่านบนหน้าเว็บไซต์ของบริษัทฯ ท่านสามารถตั้งค่าเบราเซอร์ของท่านใหม่ให้ปฏิเสธคุกกี้ทั้งหมด
หรือให้แจ้งเตือนเมื่อมีการใช้คุกกี้ 
</p>

<h3 id="bullet3">ความคุ้มครอง</h3>
<p style="text-indent: 2.5em;">
โรชใช้เทคโนโลยีและมาตรการป้องกัน รวมถึงหลักเกณฑ์และกระบวนงานต่างๆ เพื่อคุ้มครองข้อมูลส่วนบุคคลของท่านจากการเข้าถึงโดยไม่ได้รับอนุญาต
การใช้งานในทางมิชอบ การเปิดเผยข้อมูล การสร้างความเสียหาย หรือสูญหาย โรชใช้ไฟร์วอลล์และการป้องกันรหัสลับในระดับมาตรฐานอุตสาหกรรมเพื่อให้มั่นใจได้ว่าข้อมูลส่วนบุคคลของท่านถูกจัดเก็บไว้เป็นความลับ
อย่างไรก็ดี ท่านมีส่วนรับผิดชอบในการตรวจสอบให้แน่ใจว่าคอมพิวเตอร์ที่ท่านใช้มีมาตรการรักษาความปลอดภัยที่เพียงพอในการจัดการกับซอฟต์แวร์ที่สร้างความเสียหาย
อย่างเช่น โทรจัน ไวรัสคอมพิวเตอร์ และโปรแกรมหนอน พึงระลึกไว้เสมอว่า หากไม่มีมาตรการรักษาความปลอดภัยที่เพียงพอ (อาทิ การตั้งค่าการรักษาความปลอดภัยให้เบราเซอร์
การอัปเดตซอฟต์แวร์ป้องกันไวรัส การติดตั้งซอฟต์แวร์ไฟร์วอลล์ส่วนตัว ไม่ใช้ซอฟต์แวร์จากแหล่งที่น่าสงสัย) ท่านอาจมีความเสี่ยงที่ข้อมูลและรหัสผ่านที่ท่านใช้ในการเข้าถึงข้อมูลจะถูกเปิดเผยโดยบุคคลที่ไม่ได้รับอนุญาต
</p>
<h3 id="bullet4">การใช้ข้อมูล</h3>
<p style="text-indent: 2.5em;">
โรช รวมถึงบริษัทในเครือ ส่วนงานและกลุ่มงานทั่วโลก และ/หรือบริษัทที่ได้รับการว่าจ้างจากบริษัทฯ ในทำการแทน จะใช้ข้อมูลที่ใช้ระบุตัวตนได้ที่ท่านให้มาเพื่อทำตามคำขอของท่าน
บริษัทฯ จะเป็นผู้ควบคุมและรับผิดชอบในการใช้งานข้อมูลดังกล่าวนี้ ทั้งนี้ บางส่วนของข้อมูลอาจถูกจัดเก็บหรือประมวลผลโดยคอมพิวเตอร์ที่อยู่ภายใต้กฎข้อบังคับของประเทศอื่น
เช่น สหรัฐอเมริกา ที่อาจมีความแตกต่างทางด้านกฎหมายกับประเทศของท่าน ในกรณีนี้ บริษัทฯ จะมีมาตรการเพื่อให้แน่ใจได้ว่าผู้ที่ทำการประมวลผลข้อมูลจะรักษามาตรฐานการคุ้มครองข้อมูลให้เทียบเท่ากับระดับความคุ้มครองที่ได้รับในประเทศของท่าน
</p>
<p style="text-indent: 2.5em;">
ข้อมูลที่ใช้เพื่อวัตถุประสงค์ต่างๆ ทางด้านทรัพยากรบุคคล (การบริหารประสิทธิภาพการทำงาน การตัดสินใจเลือกผู้ดำรงตำแหน่งแทน หรือการสร้างพัฒนาการ)
จะช่วยให้บริษัทฯ เข้าใจความต้องการของท่านได้ดียิ่งขึ้น และสามารถปรับปรุงพัฒนาสินค้าและบริการของบริษัทฯ ให้ดีขึ้น นอกจากนี้
ยังช่วยให้บริษัทฯ สามารถสื่อสารกับท่านได้ตรงยิ่งขึ้นในการเลือกรูปแบบบริการและโปรโมชั่นที่ท่านอาจสนใจ ยกตัวอย่างเช่น บริษัทฯ
อาจทำการวิเคราะห์เพศและอายุของผู้เข้าชมเว็บไซต์ในเรื่องการใช้ยา หรือภาวะโรคบางอย่าง ที่อาจใช้เป็นชุดข้อมูลรวมเพื่อการวิเคราะห์ภายในบริษัทฯ
หรือแบ่งปันกับผู้อื่น
</p>

<h3 id="bullet5">การแบ่งปันและโอนถ่ายข้อมูล</h3>
<p style="text-indent: 2.5em;">
โรชแบ่งปันข้อมูลส่วนบุคคลที่ใช้ระบุตัวตนได้ของท่านกับบริษัทหรือตัวแทนภายนอกหลายแห่งที่ทำการบำรุงรักษาหรือทำงานทางด้านเทคโนโลยีแทนบริษัทฯ
เพื่อให้ธุรกรรมทางธุรกิจสำเร็จลุล่วงได้ อาทิ การให้บริการลูกค้า การนำเสนอข้อมูลทางการตลาดเกี่ยวกับสินค้าและบริการรวมถึงข้อเสนอต่างๆ
ของทางบริษัทฯ บริษัทฯ อาจแบ่งปันข้อมูลส่วนบุคคลที่ใช้ระบุตัวตนได้กับบริษัทสาขาและบริษัทในเครือ บริษัทและตัวแทนเหล่านี้จะต้องปฏิบัติตามระเบียบข้อบังคับในเรื่องนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัทฯ
</p>

<p style="text-indent: 2.5em;">บริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลที่ใช้ระบุตัวตนได้ในกรณีดังต่อไปนี้</p>
<ol style="margin-left: 3em;">
<li>กรณีที่เกี่ยวข้องกับการขาย การโอนสิทธิ์ หรือการโอนถ่ายธุรกิจอื่นใดของเว็บไซต์ที่เกี่ยวข้องกับข้อมูลนั้นๆ</li>
<li>กรณีที่เป็นการตอบคำร้องขอตามเหมาะสมจากหน่วยงานรัฐบาล หรือตามข้อบัญญัติทางกฎหมาย หมายศาล หรือตามระเบียบของรัฐบาล หรือ</li>
<li>กรณีที่จำเป็นเพื่อการตรวจสอบองค์กร หรือเพื่อการสืบสวน หรือเพื่อตอบข้อร้องเรียน หรือตอบสนองต่อภัยคุกคาม</li>
</ol>
<p style="text-indent: 2.5em;">
ไม่ใช้ข้อมูลเพื่อการขายตรงโดยบุคคลที่สาม บริษัทฯ จะไม่จำหน่าย
หรือโอนถ่ายข้อมูลส่วนบุคคลที่ใช้ระบุตัวตนได้ที่ท่านให้มาผ่านทางหน้าเว็บไซต์ของบริษัทฯ แก่บุคคลที่สามเพื่อใช้ในการขายตรง เว้นแต่ในกรณีที่บริษัทฯ
ได้ประกาศให้ท่านทราบและได้รับอนุญาตจากท่านแล้วอย่างชัดเจนให้สามารถแบ่งปันข้อมูลของท่านในกรณีนี้ได้
</p>
<p style="text-indent: 2.5em;">
การส่งอีเมลหาเพื่อนหรือเพื่อนร่วมงาน
ท่านสามารถเลือกที่จะส่งลิงก์หรือข้อความบนเว็บไซต์บางแห่งของโรชให้เพื่อนหรือเพื่อนร่วมงานเพื่อให้เข้ามาเยี่ยมชมเว็บไซต์ของโรชได้
อีเมลแอดเดรสของเพื่อนที่ท่านระบุไว้จะมีไว้เพื่อส่งข้อมูลให้ในนามของท่าน โดยจะไม่ถูกจัดเก็บหรือใช้เพื่อวัตถุประสงค์อื่นโดยโรช
หรือบุคคลที่สาม
</p>

<p style="text-indent: 2.5em;">
<font style="font-style: italic;">Google Analytics</font>  เว็บไซต์ของโรชอาจใช้ <a href="http://www.google.com/analytics/tos.html" targrt="_blank">Google Analytics</a> ซึ่งเป็นบริการวิเคราะห์เว็บไซต์ของ Google, Inc. ("Google")
Google Analytics ใช้ “คุกกี้” ซึ่งเป็นแฟ้มข้อมูลตัวหนังสือที่จะถูกนำไปวางไว้บนคอมพิวเตอร์ของท่าน เพื่อช่วยให้เว็บสามารทำการวิเคราะห์รูปแบบการใช้งานเว็บไซต์ของผู้ใช้
ข้อมูลการใช้เว็บไซต์ที่คุกกี้สร้างขึ้น (รวมถึงไอพีแอดเดรสของท่าน) จะถูกส่งไปยังเซิร์ฟเวอร์ของกูเกิ้ลในสหรัฐอเมริกา และถูกจัดเก็บไว้ที่นั่น
กูเกิ้ลจะใช้ข้อมูลนี้เพื่อประเมินรูปแบบการใช้เว็บไซต์ของท่าน รวบรวมและจัดทำรายงานกิจกรรมบนเว็บไซต์ให้ผู้ดูแลเว็บไซต์ และให้บริการอื่นๆ
ที่เกี่ยวข้องกับกิจกรรมบนเว็บไซต์และการใช้อินเตอร์เน็ต กูเกิ้ลอาจโอนถ่ายข้อมูลเหล่านี้ไปยังบุคคลที่สามตามข้อกำหนดทางกฎหมาย
หรือเพื่อให้บุคคลที่สามนั้นๆ สามารถปฏิบัติงานในนามของกูเกิ้ลได้ กูเกิ้ลจะไม่เชื่อมโยงไอพีแอดเดรสของท่านกับข้อมูลอื่นๆ ที่กูเกิ้ลมี
ท่านสามารถปฏิเสธการใช้คุกกี้ได้โดยการตั้งค่าตามเหมาะสมบนเบราเซอร์ของท่าน อย่างไรก็ดี ดังที่ได้กล่าวไว้แล้วข้างต้น หากท่านทำเช่นนั้น
ท่านอาจไม่สามารถใช้เว็บไซต์ของโรชได้อย่างเต็มประสิทธิภาพ การใช้เว็บไซต์ของโรช ถือเป็นความยินยอมจากท่านให้กูเกิ้ลสามารถประมวลผลข้อมูลเกี่ยวกับท่านได้ตามวัตถุประสงค์ดังที่ได้กล่าวมาข้างต้น
</p>
<h3 id="bullet6">ลิงก์ไปยังเว็บไซต์อื่น</h3>
<p style="text-indent: 2.5em;">
เว็บไซต์ของบริษัทฯ ประกอบไปด้วยลิงก์ไปยังเว็บไซต์อื่นๆ มากมายที่อาจจะให้ข้อมูลอันเป็นประโยชน์แก่ผู้มาเยี่ยมชมเว็บไซต์ของบริษัทฯ
นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ไม่ครอบคลุมไปยังเว็บไซต์เหล่านั้น บริษัทฯ แนะนำให้ท่านสื่อสารกับเว็บไซต์เหล่านั้นโดยตรงเกี่ยวกับนโยบายคุ้มครองข้อมูลส่วนบุคคลของพวกเขา
</p>
<h3 id="bullet7">นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับเยาวชน</h3>
<p style="text-indent: 2.5em;">
เว็บไซต์ของบริษัทฯ เน้นสำหรับการใช้งานโดยผู้ใหญ่ บริษัทฯ จะไม่เก็บข้อมูลส่วนบุคคลที่ใช้ระบุตัวตนได้สำหรับผู้ที่บริษัทฯ
ทราบว่ามีอายุต่ำกว่า 13 ปี หากไม่มีคำยินยอมล่วงหน้าจากตัวแทนที่ถูกต้องตามกฎหมายที่สามารถตรวจสอบรับรองได้ ตัวแทนทางกฎหมายดังกล่าว
เมื่อได้รับคำร้องขอ มีสิทธิ์ในการดูข้อมูลที่ผู้เยาว์ได้ให้ไว้ และ/หรือสามารถขอให้ลบข้อมูลนั้นได้ 
</p>
<h3 id="bullet8">ข้อมูลเพิ่มเติมบนเว็บไซต์</h3>
<p style="text-indent: 2.5em;">
หากเว็บไซต์ใดมีข้อกำหนดด้านการคุ้มครองข้อมูลส่วนบุคคลที่แตกต่างไปจากที่ได้ระบุไว้นี้ จะต้องมีการแสดงข้อกำหนดเหล่านั้นไว้บนหน้าเว็บที่จะเก็บข้อมูลส่วนบุคคลที่ใช้ระบุตัวตนได้ของท่าน
</p>
<p style="text-indent: 2.5em;" id="bullet9">
ข้อความสำหรับผู้ใช้งานเว็บไซต์ในเชิงธุรกิจหรือวิชาชีพ หากท่านมีสัมพันธภาพในเชิงธุรกิจหรือวิชาชีพกับโรช บริษัทฯ อาจใช้ข้อมูลที่ท่านให้ไว้บนเว็บไซต์ของบริษัทฯ
รวมถึงเว็บไซต์ในส่วนที่มีขึ้นเพื่อผู้ใช้งานในเชิงธุรกิจหรือวิชาชีพโดยเฉพาะเพื่อตอบคำร้องขอของท่าน และเพื่อพัฒนาความสัมพันธ์ในเชิงธุรกิจกับท่านและหน่วยงานที่ท่านเป็นตัวแทน
บริษัทฯ อาจแบ่งปันข้อมูลดักล่าวให้กับบุคคลที่สามที่ปฏิบัติงานในนามของบริษัทฯ 
</p>
<h3 id="bullet10">การปรับนโยบายคุ้มครองข้อมูลส่วนบุคคลให้เป็นปัจจุบัน</h3>
<p style="text-indent: 2.5em;">
โรชอาจมีการปรับแก้ไขนโยบายคุ้มครองข้อมูลส่วนบุคคลออนไลน์เป็นครั้งคราว โดยจะมีการแจ้งความเปลี่ยนแปลงไว้บนหน้านี้ การใช้งานเว็บไซต์ของบริษัทฯ
หลังจากได้รับประกาศแจ้งการเปลี่ยนแปลงถือว่าท่านยอมรับในข้อมูลของนโยบายใหม่ตามเงื่อนไขในการปรับแก้นโยบายคุ้มครองข้อมูลส่วนบุคคลของโรช
ทั้งนี้ ให้นโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้เริ่มมีผลบังคับใช้ตั้งแต่วันที่ <font style="color: #ff0000;">15 พฤษภาคม 2561</font> เป็นต้นไป 
</p>

<h3 id="bullet11">วิธีติดต่อโรช</h3>
<p style="text-indent: 2.5em;">
หากมีข้อสงสัยหรือต้องการให้โรชแก้ไขหรือลบข้อมูลของท่านออกจากสารระบบ กรุณาส่งเอกสาร (ทางไปรษณีย์) มาที่
</p>
<div style="margin-left: 3em">
<p style="color: #ff0000;"> 
Roche Diagnostics Asia Pacific Pte Ltd<br>
Data Privacy Coordinator<br>
8 Kallang Avenue, #10-01/09,<br> 
Aperia, Tower 1,<br>
Singapore 339509<br>
อีเมล: singapore.diag@roche.com
</p>
</div>
<p style="text-indent: 2.5em;">
นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้มีผลบังคับใช้กับ <font style="color: #ff0000;">บริษัท โรช ไดแอกโนสติกส์ เอเชีย แปซิฟิก จำกัด หรือเว็บไซต์ของบริษัท โรช
ไดแอกโนสติกส์ เอเชีย แปซิฟิก จำกัด</font> เว้นเสียแต่ว่ามีการระบุไว้อย่างชัดแจ้งให้เป็นอย่างอื่น
</p>